const DRAFT_KEY = "pantryrx.web.onboarding.draft";
const STEP_KEY = "pantryrx.web.onboarding.step";
const COMPLETED_KEY = "pantryrx.web.onboarding.completed";
const PENDING_PROFILE_KEY = "pantryrx.web.onboarding.pending_profile";

export interface OnboardingDraft {
  gender: string | null;
  height_bucket: string;
  weight_bucket: string;
  age_range: string;
  works_with_dietitian: boolean | null;
  goal: string | null;
  diet: string;
  apple_health_connected: boolean;
  push_opt_in: boolean | null;
}

export const defaultOnboardingDraft: OnboardingDraft = {
  gender: null,
  height_bucket: "prefer_not_to_say",
  weight_bucket: "prefer_not_to_say",
  age_range: "prefer_not_to_say",
  works_with_dietitian: null,
  goal: null,
  diet: "none_prefer_not_to_say",
  apple_health_connected: false,
  push_opt_in: null,
};

function safeParse<T>(raw: string | null): T | null {
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function loadOnboardingDraft(): OnboardingDraft {
  return safeParse<OnboardingDraft>(localStorage.getItem(DRAFT_KEY)) ?? defaultOnboardingDraft;
}

export function saveOnboardingDraft(draft: OnboardingDraft): void {
  localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
}

export function clearOnboardingDraft(): void {
  localStorage.removeItem(DRAFT_KEY);
  localStorage.removeItem(STEP_KEY);
}

export function loadOnboardingStep(): number {
  const raw = localStorage.getItem(STEP_KEY);
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 1) {
    return 1;
  }
  return Math.floor(parsed);
}

export function saveOnboardingStep(step: number): void {
  localStorage.setItem(STEP_KEY, String(step));
}

export function markOnboardingCompleted(): void {
  localStorage.setItem(COMPLETED_KEY, "true");
}

export function isOnboardingCompleted(): boolean {
  return localStorage.getItem(COMPLETED_KEY) === "true";
}

export function queuePendingOnboardingProfile(profile: OnboardingDraft): void {
  localStorage.setItem(PENDING_PROFILE_KEY, JSON.stringify(profile));
}

export function readPendingOnboardingProfile(): OnboardingDraft | null {
  return safeParse<OnboardingDraft>(localStorage.getItem(PENDING_PROFILE_KEY));
}

export function clearPendingOnboardingProfile(): void {
  localStorage.removeItem(PENDING_PROFILE_KEY);
}
